import { api } from 'src/boot/axios';
import { Ref } from 'vue';

export async function fetchImage(
  image: Ref<string | null>,
  url: string | null = null
) {
  if (url) {
    try {
      const response = await api.get(url, {
        responseType: 'blob',
      });
      image.value = URL.createObjectURL(response.data) ?? '';
    } catch (err) {
      console.log('Failed to load image.');
    }
  }
}
